import { ref } from 'vue';

import { _G } from '@/utils/_common';
import moment from 'moment-timezone';

// console.log(moment.utc().format("DD.MM.YYYY HH:mm:ss"));
// console.log(moment.utc(1724745307472).format(), '1724745307472');
// console.log(moment.utc(1724745401511).format(), '1724745401511');
// console.log(moment(1724745401511).format());
// console.log(moment.utc(1724750748611).format(), 'from server');

// console.log(moment.tz('UTC').toISOString());
// console.log( moment().format() );
// console.log( moment.utc().format() );
// console.log( moment.utc(1724745401511).format() );
// console.log( moment.utc(1724745401511).tz("Asia/Baku").format() );

export const G = Object.assign(_G, {
    ajaxBaseUrl: {
        // "default": `http://127.0.0.1:8000`,
        "default": `https://saoilbackend.onetrack.az`,
    },

    ajaxHeaders: {
        'X-Reguest-SaOIL': () => {
            // let a = _G.exf9('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789ÜİĞÖƏIŞÇüğöəışç!@#$%^&*()_+=-~`}{|":?></.,\';][');
            // console.log("G", moment.utc());
            let a = _G.exf9(moment.utc().valueOf());
            return btoa(a + '.' + _G.exf9('__q3$%W^Y#$5tgwsr__') + '.' + a);
        },
        // 'X-MM-Gundelik-T': () => { return btoa(
        //     _G.aEncrypt(Math.floor(new Date().valueOf()/1000).toString() + '___') + 'p0|.' + _G.aEncrypt('SmartGundelikParliament')) },
        // 'X-MM-Gundelik-D': () => { return btoa(_G.aEncrypt('web') + '___' + (_G.token_data()['id'] || '') + 'p0|.' + _G.aEncrypt('sardar.ismailov@gmail.com')) },
    },

    mediaURL: `http://localhost:8000/media/`,

    main_host: 'example.com',

    // Theme variable value equal Bootstrap colors. Example: ( primary, success, info, warning, danger, dark, light ) or custom.
    // Set your custom color in assets/css/default.css file --bs-custom-rgb variable
    theme: "custom",

    defaultSelectedMenu: "dashboard",
    defaultPage: "pages/dashboard/Dashboard",

    projectLogo: '/assets/images/logo.png',
    projectName: `Şəbəkə Monitorinqi`,
    projectTitle: `Şəbəkə <b class="project-title-span">Monitorinqi</b>`,
    projectSubtitle: "Project subtitle info",
    projectInfo: `<div class="markdown prose w-full break-words dark:prose-invert light"><p>Şəbəkə monitorinqi performansı, mövcudluğu və təhlükəsizliyi təmin etmək üçün şəbəkə əməliyyatlarına davamlı nəzarət prosesi. O, istifadəçilərə və ya biznesə təsir etməzdən əvvəl problemləri müəyyən etmək və həll etmək üçün məlumat axını, bant genişliyindən istifadə və digər əsas performans göstəricilərini izləyir.</p><p>Şəbəkə monitorinqi ilə siz:</p><ul><li> <strong>Şəbəkənin işləmə vaxtını təmin edin</strong>: Monitorinq alətləri marşrutlaşdırıcılar, açarlar, serverlər və təhlükəsizlik duvarları kimi cihazların vəziyyətini izləyən 24/7 şəbəkənizi izləyir. Cihaz sıradan çıxarsa və ya zəif işləyirsə, sistem dərhal xəbərdarlıqlar göndərir.</li><li><strong>Performansı optimallaşdırın</strong>: Bant genişliyindən istifadəni və trafik nümunələrini izləməklə administratorlar maneələri aşkarlaya və resursların optimallaşdırılmasını təmin edə bilər. və şəbəkə daxilində sürətli rabitə.</li><li><strong>Təhlükəsizliyi gücləndirin</strong>: Şəbəkə monitorinq alətləri qeyri-adi trafiki və ya icazəsiz girişi aşkar edə bilər ki, bu da potensial təhlükəsizlik pozuntusu və ya kiberhücum barədə siqnal verə bilər. Erkən aşkarlama tez bir zamanda aradan qaldırmağa imkan verir.</li><li><strong>Problemi tez aradan qaldırın</strong>: Problem yarandıqda monitorinq sistemi müfəssəl məlumat təqdim edərək, administratorlara problemi dəqiq müəyyənləşdirməyə və onu daha tez həll etməyə kömək edərək, dayanma müddətini azaldır. </li></ul><p>Məsələn, əgər işçinin cihazı zərərli proqramla yoluxmuşsa və həddən artıq bant genişliyindən istifadə etməyə başlasa, sistem dərhal şəbəkə admininə xəbərdarlıq edir. Onlar cihazı təcrid edə, problemi araşdıra və tam miqyaslı şəbəkə kəsilməsinin qarşısını ala bilərlər.</p><p>Xülasə, şəbəkə monitorinqi şəbəkənin hamar, təhlükəsiz və etibarlı əməliyyatlarını təmin edir, biznesə fasilələrdən qaçmağa, resursları optimallaşdırmağa və təhlükəsizlik təhdidlərindən qoruyun.</p></div>`,

    projectAbout: `Bu proqram Sirket terefinden hazirlanmisdir. Proqram Esas sehifeden ve onun elementlerini idare etmeye imkan yaradan "Idareetme sistemi"nden ibaretdir.<br /><br />Butun muellif huquqlari Azerbaycan Respublikasinin Qanunvericiliyi ile qorunur.`,

    footerPowered: '© 2025. <a href="https://casra.az" class="footer-info-link fw-bold" target="_blank">CASRA.AZ</a> tərəfindən <b>25 Mart 2025</b> tarixində istifadəyə verilmişdir.',
    footerDescription: '',

    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],

    // uploadedFileSize: 52428800,
    uploadedFileSize: 10485760, // 10 Mb

    showFilterAfterLength: 15,

    toastLifeTime: 3000,

    // systemData: reactive({"timezone": {"value": "UTC", "type": "text"}}),
    intervalRef: ref(null),
    intervalTimeRef: ref(15000),

    datetime_format: {
        'pg_datetime': 'YYYY-MM-DD HH:mm:ss',
        'datetime': 'DD.MM.YYYY HH:mm:ss',
        'date': 'DD.MM.YYYY',
        'time': 'HH:mm:ss',
        'hourminute': 'HH:mm',
        'for_file': 'DD.MM.YYYY__HH.mm.ss',
    },

    ignored_routes: [
        "pdf_viewer_letter",
        "pdf_viewer",
        "notfound_full",
        "notfound",
        "notperm",
        "login",
        "profile",
        "404",
        "about",
    ],

    isTheme: (theme) => {
        let themes = [
            'custom',
            'primary',
            'secondary',
            'warning',
            'danger',
            'success',
            'info',
            'dark',
        ];
        return themes.includes(theme);
    },

});
